export default "__VITE_ASSET__BR1tltA8__"